import { Badge } from "@bcc/components/ui/badge";
import type { DataTableRow } from "@client-shared";
import type { LabelPrintBatch } from "@shared/types";
import type { CellContext } from "@tanstack/react-table";
import { useTranslation } from "react-i18next";
import { getBatchStatusDisplay, setBatchesTableStatusTestId } from "../batches-table.utils";

export const BatchStatusCellMarkup = (props: CellContext<DataTableRow<LabelPrintBatch>, unknown>) => {
  const { t } = useTranslation();
  const batchStatus = props.row.original.batchStatus;
  const { labelKey, label, badgeClassName } = getBatchStatusDisplay(batchStatus);

  return (
    <Badge variant="secondary" className={badgeClassName} data-testid={setBatchesTableStatusTestId(batchStatus)}>
      {labelKey ? t(`views.batchStatus.${labelKey}`) : label}
    </Badge>
  );
};
